<template>
  <div>
    <base-header class="pb-6">
      <div class="row align-items-center py-4">
        <div class="col-lg-6 col-7">
          <h6 class="h2 text-white d-inline-block mb-0">Proyecciones de venta</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </div>
        <div class="col-lg-6 col-5 text-right">
          <router-link
            v-if="producer && $can('store', 'projections')"
            :to="{ name: 'ProducerProjectionCreate', params: { id: producer } }"
            class="btn base-button btn-neutral btn-sm mt-1"
            v-text="'Nueva'"
          >
          </router-link>
          <router-link
            v-else
            :to="{ name: 'ProjectionCreate' }"
            class="btn base-button btn-neutral btn-sm mt-1"
            v-text="'Nueva'"
          >
          </router-link>
          <router-link
            v-if="$can('generate', 'projections')"
            :to="{ name: 'ProjectionGenerate' }"
            class="btn base-button btn-neutral btn-sm mt-1"
            v-text="'Generar Automaticamente'"
          >
          </router-link>
          <router-link
            v-if="$can('statistics', 'projections')"
            :to="{ name: 'ProjectionStatistics' }"
            class="btn base-button btn-neutral btn-sm mt-1"
            v-text="'Ver Estadísticas'"
          >
          </router-link>

          <router-link
            v-if="$can('charts', 'projections')"
            :to="{ name: 'ProjectionCharts' }"
            class="btn base-button btn-neutral btn-sm mt-1"
            v-text="'Ver Gráficas'"
          >
          </router-link>
          <button
            v-if="campaign"
            class="btn base-button btn-neutral btn-sm mt-1"
            @click="campaign = null"
            v-text="'Cambiar Campaña'"
          ></button>
        </div>
      </div>
    </base-header>
    <div class="container-fluid mt--6">
      <div v-if="!campaign" class="row justify-content-center">
        <div class="col-md-6 col-sm-8 col-xs-12 card-wrapper">
          <div class="card mb-4">
            <div class="card-header">
              <h3 class="mb-0">Elija la campaña para listar las proyecciones</h3>
            </div>
            <div class="card-body">
              <campaign-select v-model="campaign" />
            </div>
          </div>
        </div>
      </div>

      <div v-if="campaign">
        <div class="row">
          <div class="col">
            <projections-table v-if="isLoaded" :title="title" :filter-campaign="campaign" :producer="producer" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
import ProjectionsTable from './List/ProjectionsTable';
import CampaignSelect from '@/components/ModelSelects/CampaignSelect';
import CurrentCampaignMixin from '@/mixins/currentCampaignMixin';

export default {
  name: 'ProjectionsList',
  components: {
    ProjectionsTable,
    RouteBreadCrumb,
    CampaignSelect,
  },

  mixins: [CurrentCampaignMixin],

  data() {
    return {
      title: 'Todas las proyecciones',
      isLoaded: true,
      producer: null,
    };
  },

  created() {
    if (this.$route.params.id) {
      this.producer = +this.$route.params.id;
      this.fetchProducer();
    }
    this.resetStateType();
  },

  methods: {
    fetchProducer() {
      this.$services
        .resource('producers')
        .show(this.producer)
        .then((res) => res.data.data)
        .then((producer) => (this.title = `Proyección para el productor: ${producer.businessName}`));
    },

    resetStateType() {
      this.$store.dispatch('navigation/setSelectedStat', null);
    },
  },
};
</script>
